// Dev-only stand-in for Healthlink's laboratory directory.
//
// Healthlink's GetAvailableServices currently returns no facility that accepts
// laboratory orders (msgtype 57) for any practice, so GET /lab-orders/facilities is
// legitimately empty and the destination picker cannot be exercised at all — see
// KIN-1390 / KIN-1486. This flag injects the hospital the backend's own UAT harness
// uses, so the flow can be clicked through end to end while that is unresolved.
//
// Submitting one of these still calls the real endpoint and will be refused
// server-side (the hospital is re-validated against the real directory), which is
// exactly what makes the 409/422 paths testable too.
//
// MUST NOT be enabled in CI or production. Guarded twice: the flag has to be "true"
// and the build must not be a production one.
const isMockEnabled =
  process.env.REACT_APP_ELAB_MOCK_FACILITIES === "true" &&
  process.env.NODE_ENV !== "production";

// Shaped like what Healthlink actually returns now that it enabled laboratory
// ordering for this practice (KIN-1486, 2026-08-07): message-type-1 facilities with a
// **blank** DepartmentAgencyCode. The last entry is deliberately synthetic — a
// hospital exposing two departments — because no real facility does, and the
// department-picking path would otherwise never be exercised.
const MOCK_FACILITIES = [
  {
    hospitalId: "1029",
    hospitalName: "CORK UNIVERSITY HOSPITAL",
    agencyCode: "",
    agencyName: null,
    hospitalGroupName: "South/South West (mock data)",
  },
  {
    hospitalId: "1041",
    hospitalName: "UNIVERSITY HOSPITAL GALWAY",
    agencyCode: "",
    agencyName: null,
    hospitalGroupName: "Saolta (mock data)",
  },
  {
    hospitalId: "1015",
    hospitalName: "OUR LADY'S HOSPITAL NAVAN",
    agencyCode: "",
    agencyName: null,
    hospitalGroupName: "Ireland East (mock data)",
  },
  {
    hospitalId: "908",
    hospitalName: "MATER MISERICORDIAE HOSPITAL (two departments, mock only)",
    agencyCode: "BIOCHEM01",
    agencyName: "Biochemistry",
    hospitalGroupName: "Ireland East (mock data)",
  },
  {
    hospitalId: "908",
    hospitalName: "MATER MISERICORDIAE HOSPITAL (two departments, mock only)",
    agencyCode: "HAEM01",
    agencyName: "Haematology",
    hospitalGroupName: "Ireland East (mock data)",
  },
];

// Only ever adds to what the backend returned, and only when the flag is on — a
// real directory is never replaced or reordered by this.
export const withMockLabFacilities = (facilities) => {
  if (!isMockEnabled) return facilities;

  console.warn(
    "[eLab] REACT_APP_ELAB_MOCK_FACILITIES is on — mock laboratories are being shown alongside the real directory."
  );

  return [...(facilities ?? []), ...MOCK_FACILITIES];
};

export const areMockLabFacilitiesEnabled = () => isMockEnabled;
